import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '../../../reusable/Autocomplete/Autocomplete.js';
import './CustomFloatingFilter.scss';


const CustomFloatingFilter = ({
  column,
  value = '',
  options,
  onValueChange,
}) => {
  // Use colId (or headerName) as the permanent key for mapping
  const mappedColKey = column.getColId(); 
  const [hasInteracted, setHasInteracted] = useState(false);

  return (
    <Autocomplete
      label={value ? '' : 'Select'}
      supportText={''}
      value={value}
      onChange={value => onValueChange && onValueChange(mappedColKey, value)}
      invalid={!value}
      classes={`custom-floating-filter-selector-field ${hasInteracted && !value ? 'ag-row-error' : ''}`}
      options={options}
      setHasInteracted={setHasInteracted}
      sortOptions={false}
    />
  );
};

CustomFloatingFilter.propTypes = {
  column: PropTypes.object.isRequired,
  value: PropTypes.string,
  options: PropTypes.array,
  onValueChange: PropTypes.func,
};

export default CustomFloatingFilter;
